import type { GridBounds, GridPoint, GridTile } from "../types/grid";
import type { LevelGridData } from "../types/level";

const TILE_TYPES: readonly GridTile[] = ["empty", "solid", "ladder"];

export function createLevelBounds(grid: LevelGridData): GridBounds {
  return {
    width: grid.width,
    height: grid.height,
  };
}

export function isPointWithinBounds(point: GridPoint, bounds: GridBounds): boolean {
  return Number.isInteger(point.x)
    && Number.isInteger(point.y)
    && point.x >= 0
    && point.x < bounds.width
    && point.y >= 0
    && point.y < bounds.height;
}

export function getGridIndex(point: GridPoint, bounds: GridBounds): number | null {
  if (!isPointWithinBounds(point, bounds)) {
    return null;
  }

  return (point.y * bounds.width) + point.x;
}

export function getTileAt(grid: LevelGridData, point: GridPoint): GridTile | null {
  const index = getGridIndex(point, createLevelBounds(grid));

  if (index === null) {
    return null;
  }

  const tileValue = grid.tiles[index];
  if (tileValue === undefined) {
    return null;
  }

  return TILE_TYPES[tileValue] ?? null;
}

export function hasPlankAt(grid: LevelGridData, point: GridPoint): boolean {
  return grid.planks.some((plank) => plank.x === point.x && plank.y === point.y);
}

export function arePointsEqual(left: GridPoint, right: GridPoint): boolean {
  return left.x === right.x && left.y === right.y;
}
